"use client";
import { jsxs as i, jsx as e } from "react/jsx-runtime";
import { cva as _ } from "class-variance-authority";
import { forwardRef as L, useState as S } from "react";
import { twMerge as T } from "tailwind-merge";
import { cn as r } from "../../../utils/utils.mjs";
import { Text as x } from "../Text/Text.mjs";
import { getAccessibleFocusStyles as V } from "../../../utils/styles.mjs";
const w = _(
  `
    px-6
    rounded-sm
    ${V()}
    cursor-pointer
    text-center
    border-transparent
    border-2
    flex
    items-center
    justify-center
    gap-x-2
    w-full
`,
  {
    variants: {
      variant: {
        primary: "bg-yellow-400 hover:bg-yellow-600 text-gray-900",
        secondary: "bg-gray-800 hover:bg-gray-900 text-white",
        "outlined-dark": "border-gray-800 text-gray-800 hover:bg-gray-900 hover:text-white",
        "outlined-light": "border-white text-white hover:text-gray-800 hover:bg-white hover:border-gray-800",
        "outlined-gradient": "border-transparent text-white",
        text: "bg-transparent text-blue-700 hover:bg-gray-100 hover:text-blue-800",
        alternate: "bg-blue-700 hover:bg-blue-800 text-white"
      },
      size: {
        default: "py-1-5 min-h-[40px]",
        large: "py-3 min-h-[56px]"
      },
      disabled: {
        true: "bg-gray-200 text-gray-500 border-gray-200 hover:border-gray-200 focus:outline-none hover:bg-gray-200 hover:text-gray-500 cursor-not-allowed"
      },
      isLink: {
        true: "inline-flex items-center"
      }
    },
    defaultVariants: {
      variant: "primary",
      size: "default"
    }
  }
), c = _("w-4 h-4 fill-current hover:fill-current", {
  variants: {
    variant: {
      primary: "fill-current hover:fill-current",
      secondary: "fill-white hover:fill-gray-900",
      "outlined-dark": "fill-gray-800 hover:fill-white",
      "outlined-light": "fill-current hover:fill-current",
      "outlined-gradient": "fill-current hover:fill-current",
      text: "fill-current hover:fill-current",
      alternate: "fill-white hover:fill-gray-200"
    },
    disabled: {
      true: "fill-gray-500 hover:fill-gray-500"
    }
  }
}), j = "bg-conic-225 from-amethyst-500 via-bubblegum-500 to-amethyst-500", A = "bg-[conic-gradient(transparent_0deg,transparent_270deg,var(--color-amethyst-500)_300deg,var(--color-orange-100)_330deg,var(--color-bubblegum-500)_345deg,transparent_360deg)]", k = "transition-opacity duration-300", R = ({ animated: a }) => /* @__PURE__ */ e(
  "span",
  {
    "aria-hidden": "true",
    className: r(
      "pointer-events-none absolute inset-0 flex items-center justify-center overflow-hidden rounded-sm p-0-5",
      "mask-[linear-gradient(black,black),linear-gradient(black,black)] [mask-clip:content-box,border-box] mask-exclude"
    ),
    children: /* @__PURE__ */ i("span", { className: "relative aspect-square w-[200%] shrink-0", children: [
      a && /* @__PURE__ */ e(
        "span",
        {
          className: r(
            "absolute inset-0",
            A,
            k,
            "animate-[spin_3s_linear_infinite] group-hover/gradient-border:opacity-0",
            /* A frozen arc reads as a rendering fault, so reduced motion drops to the full sweep below. */
            "motion-reduce:hidden"
          )
        }
      ),
      /* @__PURE__ */ e(
        "span",
        {
          className: r(
            "absolute inset-0",
            j,
            a && r(k, "opacity-0 group-hover/gradient-border:opacity-100 motion-reduce:opacity-100")
          )
        }
      )
    ] })
  }
), C = L(
  ({
    children: a,
    variant: o,
    className: N = "",
    buttonClassName: u = "",
    size: l = "default",
    disabled: t = !1,
    animatedBorder: F = !1,
    href: d,
    iconPrefix: n,
    iconSuffix: h,
    ...g
  }, m) => {
    const b = l === "large" ? "base" : "sm", [B, f] = S(!1), p = (E) => {
      E.currentTarget.matches(":focus-visible") && f(!0);
    }, y = () => f(!1), v = o === "outlined-gradient" && !t;
    let s;
    return d && !t ? s = /* @__PURE__ */ i(
      "a",
      {
        ...g,
        ref: m,
        className: r(w({ variant: o, size: l, disabled: t, isLink: !0 }), u),
        href: d,
        onFocus: p,
        onBlur: y,
        children: [
          n && /* @__PURE__ */ e("div", { className: r(c({ variant: o, disabled: t })), children: n }),
          /* @__PURE__ */ e(x, { asChild: !0, fontSize: b, children: /* @__PURE__ */ e("span", { children: a }) })
        ]
      }
    ) : s = /* @__PURE__ */ i(
      "button",
      {
        ...g,
        ref: m,
        className: r(w({ variant: o, size: l, disabled: t }), u),
        disabled: t,
        onFocus: p,
        onBlur: y,
        children: [
          n && /* @__PURE__ */ e("div", { className: r(c({ variant: o, disabled: t })), children: n }),
          /* @__PURE__ */ e(x, { asChild: !0, fontSize: b, children: /* @__PURE__ */ e("span", { children: a }) }),
          h && /* @__PURE__ */ e("div", { className: r(c({ variant: o, disabled: t })), children: h })
        ]
      }
    ), /* @__PURE__ */ i(
      "div",
      {
        className: T(
          "inline-block rounded-sm w-auto",
          v && "relative group/gradient-border",
          B && "focus-within:outline-2 focus-within:outline-white focus-within:outline-offset-2",
          N
        ),
        children: [
          v && /* @__PURE__ */ e(R, { animated: F }),
          s
        ]
      }
    );
  }
);
C.displayName = "Button";
export {
  C as Button
};
